import script from "./HomeIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeIndex.vue?vue&type=script&setup=true&lang=js"

import "./HomeIndex.vue?vue&type=style&index=0&id=5e49944c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e49944c"]])

export default __exports__